<template>
  <div>
    <v-card flat class="mx-auto" v-if="modelSelection === null">
      <v-card-title>
        <slot name="title"></slot>
      </v-card-title>
      <v-card-text>
        <slot name="subtitle"></slot>
        <ClubPicker
          @selection-changed="selectionChanged"
        ></ClubPicker>
        <slot name="footer"></slot>
      </v-card-text>
    </v-card>
    <v-card v-else>
      <ProductDetails
        :product="modelSelection"
        cancelText="Discard Club"
        @submit="submit"
        @close="clear"
      >
      </ProductDetails>
    </v-card>
  </div>
</template>

<script>
import ProductDetails from "./ProductDetails";
import ClubPicker from "./ClubPicker";
export default {
  name: "ProductSelect",
  components: {
    ClubPicker,
    ProductDetails,
  },
  data() {
    return {
      modelSelection: null,
    };
  },
  methods: {
    selectionChanged(club) {
      this.modelSelection = club;
    },
    clear() {
      this.$emit("close");
      this.modelSelection = null;
    },
    submit(productDetails) {
      this.$emit("submit", productDetails);
      this.modelSelection = null;
    },
  },
  computed: {
    // Filter models by club type
  },
};
</script>

<style scoped>
.prepend-text {
  border: 1px;
  white-space: nowrap;
  overflow: hidden;
  width: 180px;
  text-align: right;
}
</style>
